/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_New_Pnk_TitleInputs */

const vi_pkl_new_pnk_title = /** @type {(inputs: Pkl_New_Pnk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu nhập lô vật tư`)
};

/**

* @param {Pkl_New_Pnk_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_new_pnk_title = /** @type {((inputs?: Pkl_New_Pnk_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_New_Pnk_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_new_pnk_title(inputs)
});